import { MenuItem, TextField } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQueryContracts } from 'shared/queries/query-contracts';
import { ContractRouteParams } from 'shared/types/routing';
import { useViewContractsState } from './state/view-contracts-state';

interface ContractSelectionProps {
  onChange: (boolean: boolean) => void;
}

export function ContractAgainstSelection({ onChange }: ContractSelectionProps) {
  const { masterCustomer, abgBrand } = useParams<ContractRouteParams>();
  const { contracts } = useQueryContracts({ brand: abgBrand, customer: masterCustomer });
  const state = useViewContractsState();
  const initialContractAgainst = state.diffingContract.get();
  const [contractAgainst, setContractAgainst] = useState<string | undefined>(initialContractAgainst);

  const contractOptions = useMemo(
    () =>
      (contracts || []).map(contract => ({
        label: `${contract.brand} ${contract.billToCode} ${contract.originalDocumentName}`,
        path: contract.id,
      })),
    [contracts]
  );

  if (!contracts) {
    return null;
  }

  const handleDelete = () => {
    setContractAgainst(undefined);
    onChange(false);
    state.diffingContract.set(undefined);
  };

  return (
    <TextField
      size='small'
      id='contract-against-selection-select'
      label='Contract Selection'
      select
      value={contractAgainst || ''}
      fullWidth
      onChange={event => {
        const contractId = event.target.value;
        setContractAgainst(contractId);
        onChange(contractId ? true : false);
        state.diffingContract.set(contractId);
      }}
      InputProps={{ endAdornment: <ClearIcon sx={{ marginRight: '10px' }} fontSize='small' onClick={handleDelete} /> }}
    >
      <MenuItem key={undefined} value={undefined}>
        {'None'}
      </MenuItem>
      {contractOptions.map(({ label, path }) => (
        <MenuItem key={path} value={path}>
          {label}
        </MenuItem>
      ))}
    </TextField>
  );
}
